export default "<ion-app [dir]=\"rtlSide\" >\n  <app-header style=\"z-index: 10;\"></app-header>\n  <ion-router-outlet ></ion-router-outlet>\n</ion-app>\n";